module.exports = __webpack_public_path__ + "img/toolbar_top.ed29c268.png";